import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { TraineePersonalInfo } from "../../Models/Trainee";
import { InterActive } from "../../utilities/ViewModelStructure";
import { TraineeProfile } from "../../Interfaces/ResponsesData";
import { Notify } from "../../Handlers/Notifications";
import { AxiosRequest } from "../../Handlers/AxiosHandler";
import { Router } from "../../Handlers/Router";
import { Globals } from "../../Globals/GlobalObs";

export class ProfileVM extends InterActive{
    private id:string = ''
    private data?:TraineeProfile 
    private shippingData:{number:string , notes:string ,status:boolean} = { number:'' , notes:'', status:false}
    private hasNew:boolean = false
    private loaded:boolean = false

    public get Data():TraineeProfile|undefined { return this.data }
    public get ShippingData():{number:string , notes:string ,status:boolean } { return this.shippingData}
    public get HasNew():boolean{ return this.hasNew }
    public get Loaded():boolean{ return this.loaded }

    public set ShippingNumber(value:string) { this.shippingData.number = value ; this.update() }
    public set ShippingNotes(value:string) { this.shippingData.notes = value ; this.update() }
    public set HasNew(value:boolean){ this.hasNew = value; this.update() }
    public set ShippingStatus(value:boolean){ this.shippingData.status = value ; this.update() }
    public set Loaded(value:boolean) { this.loaded = value; this.update()}

    constructor(id: string){
        super()
        this.id = id

    }

    public getProfile(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.traineeProfile(this.id)
                    
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = {...response.data.data}
                                console.log(this.data.personal_info)
                                this.update()
                            }else Notify({type:'danger' , title:'1مشكلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'2مشكلة' , body:'مشكلة غير معروفة .. قد يكون هناك مشكلة فى الاتصال بالانترنت او ان المتدرب غير موجود'})
                    }
                } catch { Notify({type:'danger' , title:'3مشكلة' , body:'مشكلة غير معروفة .. قد يكون هناك مشكلة فى الاتصال بالانترنت او ان المتدرب غير موجود'}) }
                this.update()
            }
        )
    }

    public sendShipping(){
        if(this.shippingData.number.length === 0)Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال رقم الشحنة'})
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.createShippingNumber(this.id , this.shippingData.number , this.shippingData.notes, this.shippingData.status?'done':'waiting')
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.shippingData = {number:'' , notes:'' , status: false}
                                this.hasNew = false
                                this.loaded = true
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }
    public activateShipping(id:string){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.activateShippingNumber(id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.loaded = true
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }
    public deleteShipping(id:string){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.deleteShippingNumber(id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.loaded = true
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }

    public deleteTrainee(){
        this.loading(async()=>{
            try{
                let response = await AxiosRequest.statusPost<{id:string}>('deleteTrainee',{id:this.id})
                if(response){
                    if(response.status === HttpStatusCode.Ok){
                        if(response.data.status){
                            Router.OpenMasterPage(Globals.sideBar.SideBarPages[0])
                        }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                    }else  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})

                }
            }catch{
                Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
            this.update()
        })
    }

    public deleteSubscription(id:string){
        this.loading(async()=>{
            try{
                let result = await AxiosRequest.statusPost<{id:string}>('deleteSubscription',{id:id})
                if(result){
                    if(result.status === HttpStatusCode.Ok){
                        if(result.data.status){
                            try{
                                const response = await ApiRequest.traineeProfile(this.id)
                                if(response){
                                    if(response.status === HttpStatusCode.Ok){
                                        if(response.data.status){
                                            this.data = {...response.data.data}
                                            this.update()
                                        }else Notify({type:'danger' , title:'1مشكلة' , body:response.data.messege})
                                    }else Notify({type:'danger' , title:'2مشكلة' , body:'مشكلة غير معروفة .. قد يكون هناك مشكلة فى الاتصال بالانترنت او ان المتدرب غير موجود'})
                                }else  Notify({type:'danger' , title:'1مشكلة' , body:result.data.messege})
                            } catch { Notify({type:'danger' , title:'3مشكلة' , body:'مشكلة غير معروفة .. قد يكون هناك مشكلة فى الاتصال بالانترنت او ان المتدرب غير موجود'}) }
                        }
                    }else  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})

                }
            }catch{
                Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
            this.update()
        })
    }
}